import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

export function HeartBlack(props: any) {
  return (
    <Svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1095_23196)">
        <Path
          d="M16.497 31.067c-.693.006-1.363-.297-1.872-.848L3.957 17.956a9.632 9.632 0 01-1.966-3.2 10.937 10.937 0 01-.691-3.858C1.3 9.57 1.54 8.256 2 7.042A9.621 9.621 0 013.975 3.85C5.679 2.04 7.88 1.006 10.179.936c2.3-.07 4.543.828 6.325 2.532 1.782-1.703 4.026-2.6 6.325-2.53 2.299.07 4.5 1.102 6.204 2.911a9.63 9.63 0 011.976 3.2 10.94 10.94 0 01.699 3.865c0 1.331-.238 2.648-.699 3.865a9.63 9.63 0 01-1.976 3.2L18.407 30.196c-.518.563-1.199.875-1.905.872h-.005z"
          stroke="#251F2C"
          strokeWidth={2}
          strokeMiterlimit={10}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1095_23196">
          <Path fill="#fff" transform="translate(.5)" d="M0 0H32V32H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
